// extracted by mini-css-extract-plugin
module.exports = {"section-intro":"SectionIntro_section-intro__alryK","intro":"SectionIntro_intro__k698s","headline":"SectionIntro_headline__OTASu","body":"SectionIntro_body___S2N4"};